module.exports = __webpack_public_path__ + "img/sixpackcarrier89.b2db11dd.jpg";